import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCoin1"><Path fillRule="evenodd" clipRule="evenodd" d="M9.07983 4.09805C6.35341 4.68017 4 7.80007 4 12C4 16.1999 6.35341 19.3198 9.07983 19.902C7.16929 18.0298 6 15.1103 6 12C6 8.88965 7.16929 5.97015 9.07983 4.09805ZM14 22H10C5.3624 22 2 17.2744 2 12C2 6.7256 5.3624 2 10 2H14C18.6376 2 22 6.7256 22 12C22 17.2744 18.6376 22 14 22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoin1;
